const configuration = {
  namespaced: true,
  state: {
    values: new Map()
  },
  mutations: {
    setValue(state, params) {
      state.values.set(params.key, params.value);
    }
  },
  actions: {
    setValue: ({ commit }, params) => {
      commit("setValue", params);
    },
    getValue: ({ state }, key) => {
      return state.values.get(key);
    }
  },
  getters: {
    get: state => key => {
      return state.values.get(key);
    }
  }
};
//
export default configuration;
